// src/components/Debug/AccessDebugPanel.jsx
// DEV-only debug panel to inspect access state
// Usage: ?debug=1 in URL (dev mode only)

import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useAccess } from "../../contexts/AccessContext";
import { useAuth } from "../../contexts/AuthContext";

export default function AccessDebugPanel() {
  const [searchParams] = useSearchParams();
  const { user } = useAuth() || {};
  const {
    isUnlocked,
    accessLabel,
    effectiveUntil,
    trialEnds,
    accessUntil,
  } = useAccess() || {};

  const isDev = import.meta.env.DEV;
  const showDebug = isDev && searchParams.get("debug") === "1";

  const debugData = useMemo(() => ({
    userId: user?.id || "—",
    email: user?.email || "—",
    isUnlocked: String(isUnlocked),
    accessLabel: accessLabel || "—",
    effectiveUntil: effectiveUntil?.toISOString() || "—",
    trialEnds: trialEnds?.toISOString() || "—",
    accessUntil: accessUntil?.toISOString() || "—",
  }), [user, isUnlocked, accessLabel, effectiveUntil, trialEnds, accessUntil]);

  if (!showDebug) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 120,
        left: 12,
        zIndex: 10000,
        fontSize: 11,
        fontFamily: "monospace",
        backgroundColor: "rgba(0, 0, 0, 0.92)",
        color: "#0f0",
        border: "1px solid #0f0",
        borderRadius: 4,
        padding: 10,
        maxWidth: 300,
        maxHeight: 400,
        overflow: "auto",
      }}
    >
      <div style={{ marginBottom: 8, fontWeight: "bold", color: "#0f0" }}>
        [Access Debug]
      </div>
      {Object.entries(debugData).map(([key, value]) => (
        <div key={key} style={{ marginBottom: 4 }}>
          <span style={{ color: "#0f0" }}>{key}:</span>{" "}
          <span style={{ color: "#aaa" }}>
            {typeof value === "string" && value.length > 50
              ? value.substring(0, 47) + "..."
              : value}
          </span>
        </div>
      ))}
      <div style={{ marginTop: 8, fontSize: 9, color: "#666" }}>
        Remove ?debug=1 to hide
      </div>
    </div>
  );
}
